export const USER = { role: 'User', color: 'orange' };
export const MEMBER = { role: 'Member', color: 'purple' };
export const ADMIN = { role: 'Admin', color: 'blue' };
